var mandantModule = angular.module('t2g.mandantModule', [
  require('settings').name,
  require('./navigationSettings').name,
  require('./modules/firstSteps/firstStepsModule').name,
]);

module.exports = mandantModule;



// WEBPACK FOOTER //
// ./src/config/coachfrog/modules.js